import { Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { C1LinkButton } from 'components/core/button'
import { Route } from 'lib/routes'
import Image, { ImageProps } from 'next/image'
import { FC } from 'react'

type EmptyListWithIllustrationProps = {
    desktopImageProps: Omit<ImageProps, 'alt' | 'role'>
    mobileImageProps: Omit<ImageProps, 'alt' | 'role'>,
    title: string,
    body: string,
    buttonText?: string,
    buttonHref?: Route,
}

export const EmptyListWithIllustration: FC<EmptyListWithIllustrationProps> =
    ({ desktopImageProps, mobileImageProps, title, body, buttonHref, buttonText }) => {
        return <Stack direction="column" spacing={5} alignItems="center" mx={4} my={4}>
            <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
                <Image loader={({ src }): string => src} style={{ height: '100%', width: '100%' }} role="presentation" alt="" unoptimized {...desktopImageProps} />
            </Box>
            <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
                <Image loader={({ src }): string => src} role="presentation" alt="" unoptimized {...mobileImageProps} />
            </Box>
            <Stack direction="column" width={{ xs: '100%', sm: '50%' }} spacing={4} alignItems="center">
                <Stack direction="column" spacing={2} alignItems="center">
                    <Typography variant="h5" component="div">
                        {title}
                    </Typography>
                    <Typography align="center">{body}</Typography>
                </Stack>
                {buttonText && buttonHref && <C1LinkButton variant="contained" href={buttonHref}>{buttonText}</C1LinkButton>}
            </Stack>
        </Stack>
    }
